// based on vc-dialog 7.5.14
import DialogWrap from './DialogWrap';
export default DialogWrap;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-dialog/index.js
// module id = null
// module chunks = 